export const DEFAULT_CERT_TYPES = [
    'CSCS Black Card',
    'CSCS Gold Card',
    'CSCS Blue Card',
    'CSCS Green Card',
    'SMSTS',
    'SSSTS',
    'NEBOSH',
    'IOSH',
    'First Aid',
    'First Aid at Work',
    'CDM Awareness',
    'CDM Principal Designer',
    '18th Edition',
    'ECS Card',
    'APM PMQ',
    'RICS Membership',
    'NEC Contract',
    'NPORS Excavator',
    'Manual Handling',
    'Working at Height',
    'Traffic Management',
    'Banksman',
    'Gas Safe',
    'BPEC',
    'Asbestos Awareness',
    'Asbestos Management',
    'COSHH',
    'Environmental Awareness',
    'Fire Warden',
    'Slinging & Signalling',
    'PASMA',
    'Scaffold Inspection',
    'Abrasive Wheels',
    'Waste Management',
    'Vehicle Handling',
    'RAMS Preparation',
    'CITB Induction',
];
/**
 * @deprecated The training matrix is now sourced from the `CertType` table (groupName + shortKey).
 *   This constant is preserved for offline scripts and as a reference seed list — runtime code
 *   (training.service.ts, reports.service.ts) reads from Prisma and should not import this.
 */
export const MX_CERT_COLUMNS = [
    { key: 'CS', label: 'CSCS' },
    { key: 'CI', label: 'CLS Induction' },
    { key: 'AT', label: 'Asbestos' },
    { key: 'MH', label: 'Manual Handling' },
    { key: 'SO', label: 'Strip Out' },
    { key: 'CL', label: 'CLO Training' },
    { key: 'WH', label: 'Work at Height' },
    { key: 'AW', label: 'Abrasive Wheels' },
    { key: 'SI', label: 'SIA Card' },
    { key: 'IP', label: 'IPAF' },
    { key: 'AM', label: 'Asbestos Mgr/Sup' },
    { key: 'NV', label: 'NVQ' },
    { key: 'FW', label: 'Fire Warden' },
    { key: 'TM', label: 'Traffic Marshall' },
    { key: 'SM', label: 'SMSTS' },
    { key: 'SS', label: 'SSSTS' },
    { key: 'PA', label: 'PASMA' },
    { key: 'FA', label: 'First Aid' },
    { key: 'WM', label: 'Waste Mgmt' },
    { key: 'VH', label: 'Vibration HAVS' },
    { key: 'EA', label: 'Environmental' },
    { key: 'HS', label: 'H&S' },
    { key: 'NA', label: 'Noise' },
    { key: 'RP', label: 'RPE Training' },
    { key: 'ED', label: 'Equality & Div' },
    { key: 'CO', label: 'COSHH' },
    { key: 'GD', label: 'GDPR' },
    { key: 'DS', label: 'DSE' },
    { key: 'HO', label: 'Hoists' },
    { key: 'ME', label: 'MEWP' },
    { key: 'HA', label: 'Harness' },
    { key: 'NC', label: 'NEBOSH Const' },
    { key: 'NE', label: 'NEBOSH Env' },
];
export const MX_CERT_KEYS = MX_CERT_COLUMNS.map((c) => c.key);
//# sourceMappingURL=cert-types.js.map